module.exports = __webpack_public_path__ + "static/media/1233360_10205137635461022_5747798203844906519_n.4b89403d.jpg";